
import { defineComponent, PropType, computed } from 'vue'

export default defineComponent({
  name: 'ProductCard',
  props: {
    courseNo: {
      type: String,
      required: true
    },
    poolName: {
      type: String,
      required: true
    },
    poolNameImg: {
      type: String,
      default: ''
    },
    poolNameImgDark: {
      type: String,
      default: ''
    },
    remark: {
      type: String,
      default: ''
    },
    tags: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    content: {
      type: String,
      required: true
    },
    disclaimer: {
      type: String,
      default: ''
    },
    poolIcon: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  setup(props) {
    console.log('ProductCard props.theme:', props.theme)
    // 根据主题切换背景图片
    const bgImage = computed(() => {
      const isDark = props.theme === 'dark'
      const img = isDark
        ? require('@/assets/bgblack.png')
        : require('@/assets/bg.png')
      console.log('bgImage computed - theme:', props.theme, 'isDark:', isDark, 'img:', img)
      return img
    })

    // 根据主题切换产品名称图片
    const currentPoolNameImg = computed(() => {
      return props.theme == 'dark' ? props.poolNameImgDark : props.poolNameImg
    })

    // 根据主题切换问号图标
    const helpIconSrc = computed(() => {
      return props.theme === 'dark'
        ? require('@/assets/yiwenBlack.png')
        : require('@/assets/yiwen.png')
    })

    const getTagIcon = () => {
      return '✓'
    }

    return {
      getTagIcon,
      bgImage,
      currentPoolNameImg,
      helpIconSrc
    }
  }
})
